import { Page } from "layouts/finance/shared";
import Card from "@mui/material/Card";
import Pagination from "@mui/material/Pagination";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { InputAdornment, TextField, useMediaQuery, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import ApprovedMerchant from "./merchants-list.js";
import { useDashboard } from "context/DashboardContext";
import { useMerchantFilters } from "../../hooks/useMerchantFilters";

function Merchants() {
  const { allMerchants, allMerchantError, loading, fetchAllMerchant } =
    useDashboard();

  const [searchName, setSearchName] = useState("");
  const [searchID, setSearchID] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  // ✅ Pagination state (same as transactions page)
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { paginatedMerchants, filteredMerchants, totalPages } =
    useMerchantFilters({
      merchants: allMerchants,
      searchName,
      searchID,
      searchStatus: selectedStatus,
      page,
      pageSize,
    });

  // Reset page when filters/search change
  useEffect(() => {
    setPage(1);
  }, [searchName, searchID, selectedStatus]);

  return (
    <Page title="Merchants" description="Review merchant profiles, KYC documentation, and account approvals.">


      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            {/* HEADER */}
            <SoftBox
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              p={3}
              gap={2}
            >
              <SoftTypography variant='h6'>Merchants List</SoftTypography>

              <SoftBox display='flex' alignItems='center' gap={1}>
                <TextField
                  placeholder='Search by Name'
                  variant='outlined'
                  size='small'
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <SearchIcon
                          style={{ cursor: "pointer", color: "blue" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  variant='contained'
                  sx={{
            color: "#fff !important"
          }}
                  size='small'
                  startIcon={<RefreshIcon />}
                  onClick={fetchAllMerchant}
                  disabled={loading}
                >
                  Refresh
                </Button>
              </SoftBox>

              {/* SEARCH ID */}
              {/* <SoftBox display='flex' alignItems='center' gap={2}> */}
              {/* <TextField
                placeholder='Search by ID'
                variant='outlined'
                value={searchID}
                onChange={(e) => setSearchID(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <SearchIcon
                        style={{ cursor: "pointer", color: "blue" }}
                      />
                    </InputAdornment>
                  ),
                }}
              /> */}
              {/* </SoftBox> */}
            </SoftBox>

            {/* TABLE */}
            <ApprovedMerchant
              merchants={paginatedMerchants}
              loading={loading}
              error={allMerchantError}
            />

            {/* PAGINATION  */}
            {!loading && filteredMerchants.length > 0 && (
              <SoftBox
                display='flex'
                justifyContent='space-between'
                alignItems='center'
                width='100%'
                py={3}
                px={2}
              >
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={(_, value) => setPage(value)}
                  shape='rounded'
                  color='primary'
                />

                <SoftBox display='flex' alignItems='center' gap={1}>
                  <SoftTypography variant='caption'>Items/page:</SoftTypography>

                  <Select
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(e.target.value);
                      setPage(1);
                    }}
                    size='small'
                    style={{ height: 20 }}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </SoftBox>
              </SoftBox>
            )}
          </Card>
        </SoftBox>
      </SoftBox>


    </Page>
  );
}

export default Merchants;
